import React, { Component } from 'react';
import { HashRouter as Router, Route } from "react-router-dom";
import SignIn from "../auth/SignIn";
import PassReset from '../auth/PassReset';
import Dashboard from "../dashboard/Dashboard";
import Users from '../users/Users';
import Templates from '../templates/templates';
import Account from '../account/Account';
import Search from '../Search/Search';
import Search2 from '../Search/Search2';


class App extends Component {
  constructor(props) {
    super(props);
    this.state = { token: '' }
  }

  render() {
    return (
        <Router>
          <Route path="/" component={Search} exact />
          <Route path="/PassReset" component={PassReset} exact />
          <Route path="/Dashboard" component={Dashboard} exact />
          <Route path="/Users" component={Users} exact />
          <Route path="/Templates" component={Templates} exact />
          <Route path="/Account" component={Account} exact />
          <Route path="/Search2" component={Search2} exact />
        </Router>
        );
  }
}


export default App;
